import { defineStore } from 'pinia';
import { LoaderConfig } from '../types/loader';

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    isLoading: false,
    counter: 0,
    loaderConfig: {
      size: undefined,
      data: {
        text: '',
        cssClass: '',
      },
    } as LoaderConfig,
  }),
  actions: {
    setIsLoading(value: boolean) {
      this.isLoading = value;
    },
    showLoader(loaderConfig?: LoaderConfig) {
      if (loaderConfig) {
        this.loaderConfig = {
          size: loaderConfig.size,
          data: {
            text: loaderConfig.data?.text ?? '',
            cssClass: loaderConfig.data?.cssClass ?? '',
          },
        };
      }
      this.counter++;
      this.setIsLoading(true);
    },
    hideLoader() {
      this.counter--;
      if (this.counter <= 0) {
        this.setIsLoading(false);
        this.counter = 0;
        this.loaderConfig = {
          size: undefined,
          data: {
            text: '',
            cssClass: '',
          },
        };
      }
    },
    clearConfig() {
      this.loaderConfig = {
        size: undefined,
        data: {
          text: '',
          cssClass: '',
        },
      };
    }
  },
});
